import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";

import { 
    listsetting1, listsetting2, listsetting3, seltypeorcategory,
    listsetting1_2, listsetting2_2, listsetting3_2,
    listsetting1_3, listsetting2_3, listsetting3_3,     
} from '../redux/userInfo';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Radios from './Radios';
import { DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";
import Select from './Select';
import Input from './Input';
import Checkbox from './Checkbox';

export default function DetailpeeComponent(props) {

    const {
        setdetailpeeJson = () => {},
        detailpeeJson = null
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [tabs, settabs] = useState(0);   
    const [etcfeestate, setetcfeestate] = useState(false);   
    const [checkvalues, setcheckvalues] = useState([]);   
    const [dataload, setdataload] = useState(false);   
    // console.log(detailpeeJson)
    const [standard, setstandard] = useState((detailpeeJson && detailpeeJson?.length > 0) ? detailpeeJson : [
        {key: 'standard_tab', values: tabs},
        {key: 'standard_values', values: '직전월관리비', radios: [
            {names: '직전월관리비', values: '직전월관리비', textareas: false, textareasvalue: ''},
            {names: '최근 3개월 관리비 평균', values: '최근 3개월 관리비 평균', textareas: false, textareasvalue: ''},
            {names: '최근 1년 관리비 평균', values: '최근 1년 관리비 평균', textareas: false, textareasvalue: ''},
            {names: '기타', values: '기타', textareas: true, textareasvalue: ''},
        ]},
        {key: 'standard_etc', values: ''},
        {key: 'standard_tabs0JSON', values: [
            {key: 'tabs0data1', labels: '1. 공용관리비', requireCkr: true, pricetype: '정액', prices: '' },
            {key: 'tabs0data2', labels: '2. 전기료', requireCkr: true, pricetype: '정액', prices: '' },
            {key: 'tabs0data3', labels: '3. 수도료', requireCkr: true, pricetype: '정액', prices: '' },
            {key: 'tabs0data4', labels: '4. 가스사용료', requireCkr: true, pricetype: '정액', prices: '' },
            {key: 'tabs0data5', labels: '5. 난방비', requireCkr: true, pricetype: '정액', prices: '' },
            {key: 'tabs0data6', labels: '6. 인터넷사용료', requireCkr: true, pricetype: '정액', prices: '' },
            {key: 'tabs0data7', labels: '7. TV사용료', requireCkr: true, pricetype: '정액', prices: '' },
            {key: 'tabs0data8', labels: '8. 기타관리비', requireCkr: true, pricetype: '', prices: '' },
            {key: 'tabs0data9', labels: '기타관리비내용', requireCkr: true, pricetype: '', prices: '', },
        ]},
        {key: 'standard_reason_values', values: '관리규약 등에 따라 부과', radios: [
            {viewtypes: [1], names: '관리규약 등에 따라 부과', values: '관리규약 등에 따라 부과', textareas: false, textareasvalue: ''},
            {viewtypes: [1], names: '공용관리비는 면적/세대별로 부과하고 사용료는 사용량에 따른 부과', values: '공용관리비는 면적/세대별로 부과하고 사용료는 사용량에 따른 부과', textareas: false, textareasvalue: ''},
            {viewtypes: [1], names: '전체 사용량을 세대수로 나누어 부과', values: '전체 사용량을 세대수로 나누어 부과', textareas: false, textareasvalue: ''},
            {viewtypes: [1], names: '세대별 사용량(별도 계량기)에 따라 부과', values: '세대별 사용량(별도 계량기)에 따라 부과', textareas: false, textareasvalue: ''},
            {viewtypes: [1], names: '정액관리비가 10만원 미만인 경우', values: '정액관리비가 10만원 미만인 경우', textareas: false, textareasvalue: ''},
            {viewtypes: [1], names: '기타-직접입력', values: '기타-직접입력', textareas: true, textareasvalue: ''},
            {viewtypes: [3], names: '정액관리비이지만 중개의뢰인이 세부내역 미고지한 경우', values: '정액관리비이지만 중개의뢰인이 세부내역 미고지한 경우', textareas: true, textareasvalue: ''},
        ]},
        {key: 'standard_reason_price', values: ''},
        {key: 'standard_reason_sel', values: [], radios: [
            {names: '공용', values: '공용'},
            {names: '전기', values: '전기'},
            {names: '수도', values: '수도'},
            {names: '가스', values: '가스'},
            {names: '난방', values: '난방'},
            {names: '인터넷', values: '인터넷'},
            {names: 'TV', values: 'TV'},
            {names: '기타', values: '기타'},
        ]},
        {key: 'standard_no_reason_values', values: '건축법 시행령 별표1의 제1호 가목의 단독주택', radios: [
            {names: '건축법 시행령 별표1의 제1호 가목의 단독주택', values: '건축법 시행령 별표1의 제1호 가목의 단독주택'},
            {names: '오피스텔 제외 상가 건물에 해당하는 경우', values: '오피스텔 제외 상가 건물에 해당하는 경우'},
            {names: '미등기건물 신축건물 등 관리비 내역이 확인불가한 경우', values: '미등기건물 신축건물 등 관리비 내역이 확인불가한 경우'},
            {names: '관리비 없음', values: '관리비 없음', textareas: true, textareasvalue: ''},
        ]},
    ]);

    useEffect(() => {
        console.log("detailpeeJson$$$standard",standard)
        setdetailpeeJson(standard);
    }, [standard]);
    
    useEffect(() => {
        if(dataload === false){
            if(detailpeeJson === null || detailpeeJson === undefined || detailpeeJson.length === 0){
                setdataload(false);
            }else{
                // 탭(정액관리비, 기타부과, 확인불가, 정액관리비2) 선택 설정
                let findTabInfo = detailpeeJson?.find(v => v.key === "standard_tab")
                if(findTabInfo){
                    settabs(findTabInfo.values)
                }

                //기타 관리비 설정 확인
                console.log(detailpeeJson?.find(v => v?.key === "standard_tabs0JSON")?.values)
                if(detailpeeJson?.find(v => v?.key === "standard_tabs0JSON")?.values?.find(v=> v?.key === 'tabs0data8' && v?.pricetype !== '')){
                    setetcfeestate(true);
                }

                setstandard(detailpeeJson);
                setdataload(true); 
            }
            // setstandard(detailpeeJson);
            // setdataload(detailpeeJson ? true : false);
        }
    }, [detailpeeJson]);
    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div
                style={{ display: 'flex', gap: 10}}
            >
                {[
                    {tabs: 0, labels: '정액관리비'},
                    {tabs: 1, labels: '기타부과'},
                    {tabs: 2, labels: '확인불가'},
                    {tabs: 3, labels: '정액관리비2'},
                ]?.map((x, i) => {
                    return (
                        <Button
                            className={ tabs === x?.tabs ? 'linenormalbuttonbold' : 'linenormalbutton_disable'}
                            styles={{ 
                                height: 40, fontSize: 12, 
                                color:  tabs === x?.tabs ? '#6164A5' : '#999',
                                width: 80
                            }}
                            buttonTxt={x?.labels}
                            onPress={() => {
                                if(standard?.find(v => v.key === "standard_tab")){
                                    setstandard(standard?.map(v => v.key === "standard_tab" ? {...v, values: x?.tabs}: v ))
                                }else{
                                    setstandard([...standard, {key: 'standard_tab', values: x?.tabs}])
                                }
                                settabs(x?.tabs);
                            }}
                        />
                    );
                })}
            </div>
            <div style={{ width: '100%', marginTop: 10, display: 'flex', flexDirection: 'column', gap: 5 }}>
                <p style={{ color: 'red', fontSize: 11 }}>* 세부관리비는 중개사 책임하에 입력합니다.</p>
                <p style={{ fontSize: 11 }}>* 정액관리비: 정액(실비 일부 포함)으로 관리비 부과 시</p>
                <p style={{ fontSize: 11 }}>* 기타부과: 기타(정액이 아닌 경우 등)로 관리비 부과 시</p>
                <p style={{ fontSize: 11 }}>* 확인불가: 관리비 확인 불가 시</p>
                <p style={{ fontSize: 11 }}>* 정액관리비 2: 정액관리비이지만 중개의뢰인이 세부내역 미 고지 시</p>
            </div>
            {tabs === 0 &&
            <div>
                <div className='margint10' style={{ padding: '10px 0', borderTop: '1px solid #000', borderBottom: '1px solid #000'}}>
                    <div style={{ fontWeight: 700 }}>부과기준</div>
                    <div style={{ marginTop: 10 }}>
                        <Radios
                            linetype={'radioimg'}
                            values={standard?.find(item => item?.key === 'standard_values')?.values}
                            setvalues={(e) => {
                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_values' ? { ...x2, values: e} : x2 ));
                            }}
                            namevalue={standard?.find(item => item?.key === 'standard_values')?.radios}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                        />
                        {standard?.find(item => item?.key === 'standard_values')?.values === '기타' &&
                        <div className='margint8'>
                            <textarea 
                                placeholder='부과기준 기타 내용을 작성해주세요.'
                                onChange={(e) => {
                                    console.log(e?.target?.value);
                                    setstandard(standard?.map((x2, i2) => x2?.key === 'standard_values' ? { ...x2, radios: x2?.radios?.map(x3 => x3?.names === '기타' ? { ...x3, textareasvalue: e?.target?.value} : x3 )} : x2 ));
                                }}
                                value={standard?.find(item => item?.key === 'standard_values')?.radios?.find(item => item?.names === '기타')?.textareasvalue}
                                style={{
                                    width: '100%', border: '1px solid #ddd', padding: 5, borderRadius: 5, fontSize: 12,
                                    height: 60
                                }}
                            />
                        </div>
                        }
                    </div>
                </div>
                {standard?.find(item => item?.key === 'standard_tabs0JSON')?.values?.map((x, i) => {
                    if(etcfeestate === false){
                        if(i > 6){
                            return;
                        }
                    }
                    return (
                        <>
                            <div className='margint20' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <div style={{ fontWeight: 700  }}>
                                    {x?.labels} {x?.requireCkr === true && <span className='colorF00'>*</span> }
                                    {i === 7 && <p style={{ fontSize: 11, fontWeight: 400, color: 'rgb(33, 98, 221)'}}>* 기타관리비의 합산된 금액을 입력해야 합니다.</p> }
                                </div>
                                {i === 7 &&
                                <Button
                                    className={'normalbutton_middle'}
                                    buttonTxt={'-'}
                                    styles={{
                                        width: 30, height: 30, fontSize: 15, borderRadius: 100
                                    }}
                                    onPress={() => {
                                        // 기타관리비를 삭제할 경우 값 초기화 (pricetype: "", prices: "")
                                        setstandard(standard?.map((x2, i2) => x2?.key === 'standard_tabs0JSON' ? { ...x2, values: x2?.values?.map((x3, i3) => x3?.key === x?.key ? { ...x3, pricetype: "",prices: ""} : x3 )} : x2 ));
                                        setetcfeestate(false);
                                    }}
                                />}
                            </div>
                            {x?.key === 'tabs0data9' ?
                            <div className='margint8'>
                                <textarea 
                                    placeholder='기타관리비내용을 작성해 주세요.'
                                    onChange={(e) => {
                                        setstandard(standard?.map((x2, i2) => x2?.key === 'standard_tabs0JSON' ? { ...x2, values: x2?.values?.map((x3, i3) => x3?.key === x?.key ? { ...x3, prices: e?.target?.value} : x3 )} : x2 ));
                                    }}
                                    value={x?.prices}
                                    style={{
                                        width: '100%', border: '1px solid #ddd', padding: 5, borderRadius: 5, fontSize: 12,
                                        height: 60
                                    }}
                                />

                            </div>
                            :
                            <>
                            {x?.pricetype === "실비" && x?.key === "tabs0data1" &&
                            <div style={{ marginTop: 10, color: '#5C96ED'}}>*공용관리비는 실비여도 금액을 입력해야 합니다.</div>
                            }
                            <div className='margint8' style={{ display: 'flex', gap: 10 }} >

                                <div style={{ width: '40%', display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'flex-start'}}>
                                    <div style={{ }}>금액타입</div>
                                    <div style={{ width: 80 }}>
                                        <Select 
                                            styles={{}}
                                            setValues={(e) => {
                                                //실비 일경우 price 를 초기화 한다.
                                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_tabs0JSON' ? { ...x2, values: x2?.values?.map((x3, i3) => x3?.key === x?.key ? { ...x3, pricetype: e,prices:e === "실비"? "":x3.prices} : x3 )} : x2 ));
                                            }}
                                            values={x?.pricetype}
                                            selectData={[
                                                {labels: '정액', values: '정액'},
                                                {labels: '실비', values: '실비'},
                                            ]}
                                            subselectClass={'fontsize12'}
                                        />
                                    </div>
                                </div>
                                {(x?.pricetype === "실비" && x?.key === "tabs0data1") && <div style={{ width: '60%', display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'flex-end'}}>
                                    <div style={{ width: 90 }}>금액(단위 : 원)</div>
                                    <div style={{ width: 120 }}>
                                        <Input 
                                            type={'text'}
                                            className={`inputs`}
                                            rightplaceholder={'원'}
                                            placeholder=""
                                            setValue={(e) => {
                                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_tabs0JSON' ? { ...x2, values: x2?.values?.map((x3, i3) => x3?.key === x?.key ? { ...x3, prices: e} : x3 )} : x2 ));
                                            }}
                                            value={x?.prices}
                                            name={x?.key}
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 29, textAlign: 'right'
                                            }}
                                        />
                                    </div>
                                </div>}
                                {x?.pricetype !== "실비" && <div style={{ width: '60%', display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'flex-end'}}>
                                    <div style={{ width: 90 }}>금액(단위 : 원)</div>
                                    <div style={{ width: 120 }}>
                                        <Input 
                                            type={'text'}
                                            className={`inputs`}
                                            rightplaceholder={'원'}
                                            placeholder=""
                                            setValue={(e) => {
                                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_tabs0JSON' ? { ...x2, values: x2?.values?.map((x3, i3) => x3?.key === x?.key ? { ...x3, prices: e} : x3 )} : x2 ));
                                            }}
                                            value={x?.prices}
                                            name={x?.key}
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 29, textAlign: 'right'
                                            }}
                                        />
                                    </div>
                                </div>}
                            </div>   
                            </>     
                            }
                            {i === 6 && etcfeestate === false &&
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10}}>
                                <Button
                                    className={'normalbutton_middle'}
                                    buttonTxt={'기타 관리비 추가'}
                                    styles={{
                                        width: 150, height: 40, fontSize: 12
                                    }}
                                    onPress={() => {
                                        // 기타 관리비 항목에 pricetype을 '정액'으로 설정
                                        setstandard(standard?.map((x2, i2) => x2?.key === 'standard_tabs0JSON' ? { ...x2, values: x2?.values?.map((x3, i3) => x3?.key === "tabs0data8" ? { ...x3, pricetype: "정액",prices: ""} : x3 )} : x2 ));
                                        setetcfeestate(true);
                                    }}
                                />
                            </div>
                            }
                        </>                
                    );
                })}
                
            </div>
            }
            {(tabs === 1 || tabs === 3) &&
            <div>
                <div className='margint10' style={{ padding: '10px 0', borderTop: '1px solid #000', borderBottom: '1px solid #000'}}>
                    <div style={{ fontWeight: 700 }}>부과기준</div>
                    <div style={{ marginTop: 10 }}>
                        <Radios
                            linetype={'radioimg'}
                            values={standard?.find(item => item?.key === 'standard_values')?.values}
                            setvalues={(e) => {
                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_values' ? { ...x2, values: e} : x2 ));
                            }}
                            namevalue={standard?.find(item => item?.key === 'standard_values')?.radios}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                        />
                        {standard?.find(item => item?.key === 'standard_values')?.values === '기타' &&
                        <div className='margint8'>
                            <textarea 
                                placeholder='부과기준 기타 내용을 작성해주세요.'
                                onChange={(e) => {
                                    console.log(e?.target?.value);
                                    setstandard(standard?.map((x2, i2) => x2?.key === 'standard_values' ? { ...x2, radios: x2?.radios?.map(x3 => x3?.names === '기타' ? { ...x3, textareasvalue: e?.target?.value} : x3 )} : x2 ));
                                }}
                                value={standard?.find(item => item?.key === 'standard_values')?.radios?.find(item => item?.names === '기타')?.textareasvalue}
                                style={{
                                    width: '100%', border: '1px solid #ddd', padding: 5, borderRadius: 5, fontSize: 12,
                                    height: 60
                                }}
                            />
                        </div>
                        }
                    </div>
                </div>
                <div className='' style={{ padding: '10px 0', borderBottom: '1px solid #000'}}>
                    <div style={{ fontWeight: 700 }}>부과사유</div>
                    <div style={{ marginTop: 10 }}>
                        <Radios
                            linetype={'radioimg'}
                            widths={'100%'}
                            values={standard?.find(item => item?.key === 'standard_reason_values')?.values}
                            setvalues={(e) => {
                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_reason_values' ? { ...x2, values: e} : x2 ));
                            }}
                            namevalue={standard?.find(item => item?.key === 'standard_reason_values')?.radios.filter(item => item?.viewtypes?.includes(tabs*1))}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                        />
                        {(standard?.find(item => item?.key === 'standard_reason_values')?.values === '기타-직접입력' || tabs === 3) &&
                        <div className='margint8'>
                            <textarea 
                                placeholder='부과사유 기타 내용을 작성해주세요.'
                                onChange={(e) => {
                                    console.log(e?.target?.value);
                                    setstandard(standard?.map((x2, i2) => x2?.key === 'standard_reason_values' ? { ...x2, radios: x2?.radios?.map(x3 => x3?.names === '기타-직접입력' ? { ...x3, textareasvalue: e?.target?.value} : x3 )} : x2 ));
                                }}
                                value={standard?.find(item => item?.key === 'standard_reason_values')?.radios?.find(item => item?.names === '기타-직접입력')?.textareasvalue}
                                style={{
                                    width: '100%', border: '1px solid #ddd', padding: 5, borderRadius: 5, fontSize: 12,
                                    height: 60
                                }}
                            />
                        </div>
                        }
                    </div>
                </div>
                <div className='' style={{ 
                    padding: '10px 0', borderBottom: '1px solid #000', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 10
                }}>
                    <div style={{ fontWeight: 700 }}>금액(단위 : 원)</div>
                    <div style={{ }}>
                        <Input 
                            type={'text'}
                            className={`inputs`}
                            rightplaceholder={'원'}
                            placeholder=""
                            setValue={(e) => {
                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_reason_price' ? { ...x2, values: e} : x2 ));
                            }}
                            value={standard?.find(item => item?.key === 'standard_reason_price')?.values}
                            name={'standard_reason_price'}
                            zerostatus={true}
                            style={{
                                paddingRight: 29, textAlign: 'right'
                            }}
                        />
                    </div>
                </div>
                <div className='' style={{ padding: '10px 0', borderBottom: '1px solid #000'}}>
                    <div style={{ fontWeight: 700 }}>포함항목</div>
                    <div style={{ marginTop: 10 }}>
                        <Checkbox
                            linetype={'checkimg'}
                            values={standard?.find(item => item?.key === 'standard_reason_sel')?.values}
                            setvalues={(e) => {
                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_reason_sel' ? { ...x2, values: e} : x2 ));
                            }}
                            namevalue={standard?.find(item => item?.key === 'standard_reason_sel')?.radios}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                        />
                        
                    </div>
                </div>
            </div>
            }      
            {tabs === 2 &&
            <div>
                <div className='margint10' style={{ padding: '10px 0', borderTop: '1px solid #000'}}>
                    <div style={{ fontWeight: 700 }}>확인불가사유</div>
                    <div style={{ marginTop: 10 }}>
                        <Radios
                            linetype={'radioimg'}
                            widths={'100%'}
                            values={standard?.find(item => item?.key === 'standard_no_reason_values')?.values}
                            setvalues={(e) => {
                                setstandard(standard?.map((x2, i2) => x2?.key === 'standard_no_reason_values' ? { ...x2, values: e} : x2 ));
                            }}
                            namevalue={standard?.find(item => item?.key === 'standard_no_reason_values')?.radios}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                        />
                        {standard?.find(item => item?.key === 'standard_no_reason_values')?.values === '관리비 없음' &&
                        <div className='margint8'>
                            <textarea 
                                placeholder='관리비 없음에 대한 사유 입력.'
                                onChange={(e) => {
                                    console.log(e?.target?.value);
                                    setstandard(standard?.map((x2, i2) => x2?.key === 'standard_no_reason_values' ? { ...x2, radios: x2?.radios?.map(x3 => x3?.names === '관리비 없음' ? { ...x3, textareasvalue: e?.target?.value} : x3 )} : x2 ));
                                }}
                                value={standard?.find(item => item?.key === 'standard_no_reason_values')?.radios?.find(item => item?.names === '관리비 없음')?.textareasvalue}
                                style={{
                                    width: '100%', border: '1px solid #ddd', padding: 5, borderRadius: 5, fontSize: 12,
                                    height: 60
                                }}
                            />
                        </div>
                        }
                    </div>
                </div>       
            </div>     
            }      
        </div>
    )    
}